// src/components/Toast.js
import { createContext, useContext, useState } from "react";
import "./Toast.css";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [message, setMessage] = useState("");
  const [type, setType] = useState("info");
  const [visible, setVisible] = useState(false);

  function show(msg, type = "info") {
    setMessage(msg);
    setType(type);
    setVisible(true);

    setTimeout(() => setVisible(false), 2500);
  }

  return (
    <ToastContext.Provider value={{ show }}>
      {children}

      {visible && (
        <div className={`toast toast-${type}`}>
          {message}
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
